import { useCurrentWorkspace } from "@v2/contexts/WorkspaceDashboardContext";
import { useSubscriptionDetails } from "@v2/hooks/subscription";
import { useLocalStorageState } from "@v2/hooks/useLocalStorage";
import { z } from "zod";

const useHasFailedPayment = () => {
  const workspace = useCurrentWorkspace();
  const workspaceId = workspace?.id;

  const { data: activeSubscription } = useSubscriptionDetails();

  const [showDebugFailedPaymentState] = useLocalStorageState(
    "replo.debug.showFailedPaymentState",
    false,
    { schema: z.boolean() },
  );

  return (
    showDebugFailedPaymentState ||
    (workspaceId &&
      activeSubscription?.paymentProcessor === "stripe" &&
      activeSubscription?.paymentFailedAt !== null)
  );
};

export default useHasFailedPayment;
